// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"150":"6427877106f4a7d4","273":"cca6def6203ddab0"}[chunkId] + ".css";
};